import * as React from "react";
import type { SVGProps } from "react";
const SvgCoinComingIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="coin_coming_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M896 512a384 384 0 1 0-768 0 384 384 0 0 0 768 0zM512 42.667C771.2 42.667 981.333 252.8 981.333 512S771.2 981.333 512 981.333 42.667 771.2 42.667 512 252.8 42.667 512 42.667zM554.667 256a42.667 42.667 0 1 0-85.334 0v256a42.667 42.667 0 0 0 23.595 38.144l170.667 85.333a42.667 42.667 0 1 0 38.144-76.288l-147.072-73.557V256z"
    />
  </svg>
);
export default SvgCoinComingIcon;
